
import MeetYourCoach from "@/components/MeetYourCoach";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

const Coach = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <div className="pt-8">
        <MeetYourCoach />
      </div>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Coach;
